<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">


      <Form ref="formValidate" :model="params" :rules="ruleValidate" label-position="top">
        <FormItem label="上传图片：" prop="siteImg">
            <div class="j-img-echo">
                <template v-if="!params.siteImg">
                    <Icon type="md-images" size="55" color="#c5c8ce" />
                </template>
                <template v-else>
                    <img :src="params.siteImg">
                </template>
            </div>
            <Upload :action="action" :headers="headers" :show-upload-list="false" name="file" :on-success="uploadSuccess">
                <Button icon="ios-cloud-upload-outline" style="width:488px">上传站点图片</Button>
            </Upload>
            <Alert show-icon closable style="margin-top:10px">建议上传140*140尺寸并且大小不能大于500kb的图片</Alert>
        </FormItem>
        <FormItem label="仓库名称：" prop="name">
          <Input v-model.trim="params.name" placeholder="请输入仓库名称"></Input>
        </FormItem>
        <FormItem label="联系方式（登录账号）：" prop="phone">
          <Input v-model.trim="params.phone" placeholder="请输入联系方式"></Input>
        </FormItem>
        <FormItem label="开放时间：" prop="openTime">
          <Input v-model.trim="params.openTime" placeholder="请输入开放时间"></Input>
        </FormItem>
        <FormItem label="仓库地址：" prop="address">
          <Input v-model.trim="params.address" placeholder="请输入详细地址"></Input>
        </FormItem>
        <FormItem label="经度：" prop="longitude">
          <Input v-model.trim="params.longitude" readonly placeholder="请点击地图选择经度" disabled></Input>
        </FormItem>
        <FormItem label="纬度：" prop="latitude">
          <Input v-model.trim="params.latitude" readonly placeholder="请点击地图选择纬度" disabled></Input>
        </FormItem>
        <FormItem label="地图选点：">
          <Button type="primary" @click="openMapPicker" :disabled="type === 1">地图选点</Button>
          <span class="map-picker-tip">
            {{ mapPicker.selectedAddress || '点击按钮后可在地图上选点，自动回填地址和经纬度' }}
          </span>
        </FormItem>
      </Form>


      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
        <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
          <span v-if="!loadingBtn">确定</span>
          <span v-else>请稍候...</span>
        </Button>
      </div>
    </Modal>

    <Modal
      v-model="mapPicker.visible"
      title="地图选点"
      width="1000"
      :mask-closable="false"
      @on-cancel="cancelMapPicker"
    >
      <div class="map-picker-box">
        <div class="map-picker-toolbar">
          <Input
            v-model.trim="mapPicker.keyword"
            placeholder="请输入地址关键字后回车搜索"
            search
            enter-button
            @on-search="searchMapKeyword"
          />
          <div class="map-picker-info">
            <div>经度：{{ mapPicker.selectedLng || '-' }}</div>
            <div>纬度：{{ mapPicker.selectedLat || '-' }}</div>
            <div>地址：{{ mapPicker.selectedAddress || '请在地图上点击选择点位' }}</div>
          </div>
        </div>
        <div id="site-map-picker"></div>
      </div>
      <div slot="footer">
        <Button @click="cancelMapPicker">取消</Button>
        <Button type="primary" @click="confirmMapPicker">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      action: this.$uploadURL,
      headers: {
        token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
      },
      title: '查看信息',
      type: 0,
      params: {
        siteId: '',
        name: '',
        phone: '',
        address: '',
        longitude: '',
        latitude: '',
        siteImg: '',
        openTime: ''
      },
      ruleValidate: {
        name: [
          {required: true, message: '仓库名称不能为空', trigger: 'change'},
        ],
        phone: [
          {required: true, message: '联系方式不能为空', trigger: 'change'},
        ],
        address: [
          {required: true, message: '仓库地址不能为空', trigger: 'change'},
        ],
        longitude: [
          {required: true, message: '经度不能为空', trigger: 'change'},
        ],
        latitude: [
          {required: true, message: '纬度不能为空', trigger: 'change'},
        ]
      },
      mapPicker: {
        visible: false,
        keyword: '',
        map: null,
        marker: null,
        geocoder: null,
        localSearch: null,
        clickHandler: null,
        selectedLng: '',
        selectedLat: '',
        selectedAddress: ''
      }
    }
  },
  methods: {
    // 点击提交验证
    handleSubmit(name) {
      // console.log(this.params);
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$Message.error('验证通过');
          /**
           * type判断
           * 1.查看 2.新增 3.编辑
           */
          switch (this.type) {
            case 1:
              // this.title = '查看仓库';
              break;
            case 2:
              // 新增仓库
              this.addUser();
              break;
            case 3:
              // 编辑仓库
              this.updateUser();
              break;
            default:
              this.$Notice.error({
                title: '仓库管理',
                desc: '查看，新增，编辑区分判断报错',
                duration: 0
              });
              break
          }
        } else {
          this.$Message.error('还有信息没有填写合格哦~');
        }
      })
    },
    // 显示模态框
    show(type, row) {
      this.isShowModal = true;
      this.type = type;
      this.mapPicker.selectedAddress = '';
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      switch (type) {
        case 1:
          this.title = '查看仓库';
          this.getInfo(row);
          break;
        case 2:
          this.title = '新增仓库';
          break;
        case 3:
          this.title = '编辑仓库';
          this.getInfo(row);
          break;
        default:
          this.$Notice.error({
            title: '仓库管理',
            desc: '查看，新增，编辑模态框报错',
            duration: 0
          });
          break
      }
    },
    // 新增仓库
    addUser() {
      this.$Spin.show();
      this.axios.post('/site/add', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$emit('changeDate');
          this.$Message.success('操作成功.');
          this.hide('formValidate');
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '新增仓库接口报错',
            duration: 0
          });
        }
      })
    },
    // 编辑仓库
    updateUser() {
      this.$Spin.show();
      this.axios.post('/site/update', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$emit('changeDate');
          this.$Message.success('操作成功.');
          this.hide('formValidate');
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '编辑仓库接口报错',
            duration: 0
          });
        }
      })
    },
    // 查询仓库详情
    getInfo(row) {
      this.$Spin.show();
      this.axios.post('/site/findSiteById', {
        siteId: row.siteId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          // this.$Message.success('操作成功.');
          this.params.name = res.data.name;
          this.params.phone = res.data.phone;
          this.params.address = res.data.address;
          this.params.longitude = res.data.longitude;
          this.params.latitude = res.data.latitude;
          this.params.siteImg = res.data.siteImg;
          this.params.siteId = res.data.siteId;
          this.params.openTime = res.data.openTime;
          this.mapPicker.selectedAddress = res.data.address;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查看仓库详情接口报错',
            duration: 0
          });
        }
      })
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response.status == 200) {
        this.params.siteImg = response.data;
      }
      if (response.status == 201) {
        this.$Message.error(response.msg);
      }
      if (response.status == 500) {
        this.$Notice.error({
          title: '服务器内部错误',
          desc: '上传仓库接口报错',
          duration: 0
        });
      }
    },
    openMapPicker() {
      this.mapPicker.visible = true;
      this.mapPicker.keyword = this.params.address || '';
      this.mapPicker.selectedLng = this.params.longitude || '';
      this.mapPicker.selectedLat = this.params.latitude || '';
      this.mapPicker.selectedAddress = this.params.address || '';
      this.$nextTick(() => {
        setTimeout(() => {
          this.initMapPicker();
        }, 100);
      });
    },
    initMapPicker() {
      const point = this.getCurrentPoint();
      if (!this.mapPicker.map) {
        this.mapPicker.map = new BMap.Map('site-map-picker', {
          enableMapClick: false,
          minZoom: 5,
          maxZoom: 19,
        });
        this.mapPicker.map.enableScrollWheelZoom(true);
        this.mapPicker.geocoder = new BMap.Geocoder();
        this.mapPicker.localSearch = new BMap.LocalSearch(this.mapPicker.map, {
          renderOptions: { map: this.mapPicker.map }
        });
      }
      this.mapPicker.map.clearOverlays();
      this.mapPicker.map.centerAndZoom(point, this.params.longitude && this.params.latitude ? 16 : 12);
      this.mapPicker.marker = new BMap.Marker(point);
      this.mapPicker.map.addOverlay(this.mapPicker.marker);
      if (this.mapPicker.clickHandler) {
        this.mapPicker.map.removeEventListener('click', this.mapPicker.clickHandler);
      }
      this.mapPicker.clickHandler = (event) => {
        this.handleMapClick(event);
      };
      this.mapPicker.map.addEventListener('click', this.mapPicker.clickHandler);
      this.fillSelectedPoint(point, this.mapPicker.selectedAddress);
    },
    getCurrentPoint() {
      const lng = Number(this.params.longitude);
      const lat = Number(this.params.latitude);
      if (!Number.isNaN(lng) && !Number.isNaN(lat) && lng && lat) {
        return new BMap.Point(lng, lat);
      }
      return new BMap.Point(121.45, 37.46);
    },
    handleMapClick(event) {
      if (!event || !event.point) {
        return;
      }
      this.setMapMarker(event.point);
      this.reverseGeocode(event.point);
    },
    setMapMarker(point) {
      if (!this.mapPicker.map) {
        return;
      }
      this.mapPicker.map.clearOverlays();
      this.mapPicker.marker = new BMap.Marker(point);
      this.mapPicker.map.addOverlay(this.mapPicker.marker);
      this.mapPicker.map.panTo(point);
    },
    reverseGeocode(point) {
      if (!this.mapPicker.geocoder) {
        return;
      }
      this.mapPicker.geocoder.getLocation(point, (result) => {
        const address = result && result.address ? result.address : '';
        this.fillSelectedPoint(point, address);
      });
    },
    fillSelectedPoint(point, address) {
      this.mapPicker.selectedLng = point.lng.toFixed(6);
      this.mapPicker.selectedLat = point.lat.toFixed(6);
      if (address) {
        this.mapPicker.selectedAddress = address;
      }
    },
    searchMapKeyword() {
      if (!this.mapPicker.localSearch || !this.mapPicker.keyword) {
        return;
      }
      this.mapPicker.localSearch.setSearchCompleteCallback((searchResult) => {
        if (!searchResult || searchResult.getCurrentNumPois() === 0) {
          this.$Message.warning('未搜索到相关地址，请尝试更换关键字');
          return;
        }
        const poi = searchResult.getPoi(0);
        if (!poi || !poi.point) {
          return;
        }
        this.setMapMarker(poi.point);
        this.fillSelectedPoint(poi.point, poi.address || poi.title || this.mapPicker.keyword);
      });
      this.mapPicker.localSearch.search(this.mapPicker.keyword);
    },
    confirmMapPicker() {
      if (!this.mapPicker.selectedLng || !this.mapPicker.selectedLat) {
        this.$Message.warning('请先在地图上点击选择点位');
        return;
      }
      this.params.longitude = this.mapPicker.selectedLng;
      this.params.latitude = this.mapPicker.selectedLat;
      if (this.mapPicker.selectedAddress) {
        this.params.address = this.mapPicker.selectedAddress;
      }
      this.mapPicker.visible = false;
    },
    cancelMapPicker() {
      this.mapPicker.visible = false;
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      this.mapPicker.visible = false;
      this.mapPicker.keyword = '';
      this.mapPicker.selectedLng = '';
      this.mapPicker.selectedLat = '';
      this.mapPicker.selectedAddress = '';
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped>
.map-picker-tip {
  display: inline-block;
  margin-left: 12px;
  color: #808695;
}

.map-picker-box {
  width: 100%;
}

.map-picker-toolbar {
  margin-bottom: 12px;
}

.map-picker-info {
  margin-top: 12px;
  line-height: 1.8;
  color: #515a6e;
}

#site-map-picker {
  width: 100%;
  height: 500px;
}
</style>
